/* eslint-disable linebreak-style */
/* eslint-disable-next-line linebreak-style */
export var outlined = {
    '& .MuiChip-label': {
        padding: '4px 8px',
    },
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '4px',
    boxShadow: 'unset',
    fontFamily: 'Nunito Sans',
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '16px',
    letterSpacing: '0.01em',
    textAlign: 'center',
    '&:hover': {},
    '&:focus': {
        backgroundImage: 'linear-gradient(rgba(73, 69, 79, 0.08),rgba(73, 69, 79, 0.12))',
    },
};
export var elevated = {
    borderRadius: '4px',
    fontWeight: '600',
    '& .MuiChip-label': {
        padding: '4px 8px',
    },
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)',
    '&:hover': {},
    '&:focus': {
        backgroundImage: 'linear-gradient(rgba(73, 69, 79, 0.08),rgba(73, 69, 79, 0.12))',
    },
};
export var filled = {
    borderRadius: '4px',
    fontWeight: '600',
    '& .MuiChip-label': {
        padding: '4px 8px',
    },
    boxShadow: 'unset',
    '&:hover': {},
    '&:focus': {
        backgroundImage: 'linear-gradient(rgba(73, 69, 79, 0.08),rgba(73, 69, 79, 0.12))',
    },
};
